import type {
  ResolutionStatus,
  VisioReviewConfig,
  VisioReviewManagerEvaluation,
} from '@gozoki/api-types'
import { gozokiApiWithAuth } from '../gozokiApi'

export const saveManagerEvaluation = async (
  reviewId: number,
  data: VisioReviewManagerEvaluation,
) => {
  const res = await gozokiApiWithAuth.patch(`/visio-reviews/${reviewId}/evaluate`, data)
  return res.data
}

export const updateVisioReviewConfig = async (data: Partial<VisioReviewConfig>) => {
  const res = await gozokiApiWithAuth.patch<VisioReviewConfig>('/visio-reviews/config', data)
  return res.data
}

export const validateVisioReviewAiGrade = async (reviewId: number) => {
  const res = await gozokiApiWithAuth.patch(`/visio-reviews/${reviewId}/validate-ai-grade`)
  return res.data
}

export const updateVisioReviewResolution = async (
  reviewId: number,
  data: { resolutionStatus: ResolutionStatus },
) => {
  const res = await gozokiApiWithAuth.patch(`/visio-reviews/${reviewId}/resolution`, data)
  return res.data
}
